import { map } from 'rxjs/operators';
import { AppInitService } from './../../services/app-init.service';
import {
  AfterViewInit,
  Component,
  DoCheck,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';
import {
  InputType,
  isCompareInput,
  isRangeInput,
  ComboPropConfig,
  DataPropConfig,
  getValidations,
  rangePickerValidation,
  ComponentConfig as CC1,
} from 'dg-input-lib';

import { ComponentConfig as CC2 } from 'dg-common-directives-lib';
import { Validation } from 'dg-error-lib';
import { Observable } from 'rxjs';
import { MaskPipe } from 'ngx-mask';
import { HttpClient } from '@angular/common/http';

interface InputDataModel {
  inputId: string | number;
  inputType: string | number;
  inputName?: string;
  inputPlaceholder?: string | { separator?: string; from: string; to: string };
  inputMandatory?: boolean;
  inputOptions?: ComboModel[] | ((term: string) => Observable<ComboModel[]>);
  inputValue?: unknown;
  validations?: Validation[];
  pipe?: { instance: any; parameters: any[] };
  hint?: string;
  orgConfig?: unknown;
  postConfig?: unknown;
  empConfig?: unknown;
  inputDisabled?: boolean;
  [key: string]: any;
}

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-dg-dynamic-input-test',
  templateUrl: './dg-dynamic-input-test.component.html',
  styleUrls: ['./dg-dynamic-input-test.component.scss'],
})
export class DgDynamicInputTestComponent
  implements OnInit, AfterViewInit, DoCheck {
  inputDataPropConfig: DataPropConfig = {
    idProp: 'inputId',
    typeProp: 'inputType',
    nameProp: 'inputName',
    placeholderProp: 'inputPlaceholder',
    requiredProp: 'inputMandatory',
    comboProp: 'inputOptions',
    validationsProp: 'validations',
    hintProp: 'hint',
    pipeProp: 'pipe',
    disabledProp: 'inputDisabled',
    suffixProp: 'suffix',
    autocompleteProp: 'autocomplete',
    labelClassProp: 'labelClass',
    suffixTemplateProp: 'suffixTemplate',
    readOnlyProp: 'readOnly',
  };

  comboPropConfig: ComboPropConfig = {
    labelProp: 'optionText',
    valueProp: 'optionValue',
    rangeProp: 'isRange',
    descriptionProp: 'optionDesc',
    disabledProp: 'optionDisabled',
    iconProp: 'optionIcon',
    styleProp: 'optionStyle',
  };

  doc_url;

  showLabel = true;

  mandatory = false;

  showDefaultValue = false;

  comboData: ComboModel[] = [
    {
      optionValue: '3000865',
      optionText: 'Law',
      optionDisabled: true,
      optionIcon: 'message',
      parent: 'Departments',
    },
    {
      optionValue: '70001572',
      optionText: 'SS1',
      optionDisabled: false,
      optionIcon: 'notifications',
      parent: 'Departments',
    },
    {
      optionValue: '3000866',
      optionText: 'Report',
      optionDisabled: false,
      optionIcon: 'visibility',
      parent: 'Sections',
      optionStyle: { 'font-weight': 'bold' },
      optionDesc: 'asdfsdf sdafdsa fdsf dsafdssf ds dsfasd',
    },
    {
      optionValue: '70001573',
      optionText: 'Drilldown',
      optionDisabled: false,
      optionIcon: 'add',
      parent: 'Sections',
    },
    {
      optionValue: '70001574',
      optionText: 'Dummy',
      optionDisabled: false,
      optionIcon: 'accessibility',
      parent: 'Sections',
    },
    {
      optionValue: '70001575',
      optionText: 'Sample',
      optionDisabled: false,
      optionIcon: 'extension',
      parent: 'Sections',
    },
    {
      optionValue: '70001576',
      optionText: 'Fake',
      optionDisabled: false,
      optionIcon: 'android',
      parent: 'Sections',
    },
    {
      optionValue: '70001577',
      optionText: 'John',
      optionDisabled: false,
      optionIcon: 'gavel',
      parent: 'Sections',
    },
    {
      optionValue: '70001578',
      optionText: 'Doe',
      optionDisabled: false,
      optionIcon: 'tips_and_updates',
      parent: 'Sections',
    },
  ] /* Array(100)
    .fill(undefined)
    .map((item, index) => ({
      optionText:
        'I am a very very very long optionText to check overflow' +
        index.toString(),
      optionDesc:
        'I am a very very very long optionText to check overflow description' +
        index.toString(),
      optionValue: index,
      optionDisabled: index % 2 == 0
    })) */;

  compareOptions: ComboModel[] = [
    { id: 0, optionText: 'Select', optionValue: -1, optionDesc: 'Select' },
    { id: 1, optionText: '==', optionValue: 1, optionDesc: 'Equal To' },
    { id: 2, optionText: '<', optionValue: 2, optionDesc: 'Less Than' },
    { id: 3, optionText: '>', optionValue: 3, optionDesc: 'Greater Than' },
    {
      id: 4,
      optionText: 'Between',
      optionValue: 4,
      optionDesc: 'Between',
      isRange: true,
    },
    {
      id: 5,
      optionText: '<=',
      optionValue: 5,
      optionDesc: 'Less Than Equal To',
    },
    {
      id: 6,
      optionText: '>=',
      optionValue: 6,
      optionDesc: 'Greater Than Equal To',
    },
    { id: 7, optionText: '!=', optionValue: 7, optionDesc: 'Not Equal To' },
  ];

  inputData: InputDataModel[];

  dgDynamicInputFormGroup: FormGroup;

  @ViewChild('dgDynamicInputSuffixTemplate')
  dgDynamicInputSuffixTemplate: TemplateRef<any>;
  constructor(private maskPipe: MaskPipe, private http: HttpClient) {
    this.dgDynamicInputFormGroup = new FormGroup({});
  }

  getFakeData = (): InputDataModel[] => [
    {
      inputId: 'date',
      inputType: InputType.DATE,
      inputName: 'Date',
      readOnly: true,
      inputPlaceholder: 'Enter a date',
      inputMandatory: this.mandatory,
      inputValue: this.showDefaultValue ? '2021-03-01T13:37:38.548Z' : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Date is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'number',
      inputType: InputType.NUMBER,
      inputName: 'Number',
      inputPlaceholder: 'Enter a number',
      inputMandatory: this.mandatory,
      inputValue: this.showDefaultValue ? 33 : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Number is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'dateRange',
      inputType: InputType.DATE_RANGE,
      inputName: 'Date Range',
      inputPlaceholder: 'Select date range',
      inputMandatory: this.mandatory,
      inputValue: this.showDefaultValue
        ? {
            from: '2021-03-01T13:37:38.548Z',
            to: '2021-03-01T13:37:38.548Z',
          }
        : null,
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'complex',
              value: {
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Date Range is required',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Date Range is required',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : undefined,
    },
    {
      inputId: 'text',
      inputType: InputType.TEXT,
      inputName: 'Text',
      inputPlaceholder: 'Enter text',
      inputMandatory: this.mandatory,
      inputDisabled: false,
      hint: 'i m a hint',
      labelClass: 'optional-field',
      autocomplete: true,
      // suffix: 'save',
      /* pipe: { instance: this.maskPipe, parameters: ['000-000-0000'] }, */
      inputValue: this.showDefaultValue ? '8888888888' : null,
      suffixTemplate: this.dgDynamicInputSuffixTemplate,
      validations: this.mandatory
        ? [
            {
              async: false,
              type: 'custom',
              errorMessage: 'custom validation error',
              value: ((control: FormControl) =>
                control.value === 'custom'
                  ? { custom: true }
                  : null) as ValidatorFn,
            },
            {
              async: false,
              errorMessage: `Text is required. Intentionally making this message very very long to benchmark results. Intentionally making this message very very long to benchmark results. Intentionally making this message very very long to benchmark results. Intentionally making this message very very long to benchmark results. Intentionally making this message very very long to benchmark results. Intentionally making this message very very long to benchmark results. `,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'numberRange',
      inputType: InputType.NUMBER_RANGE,
      inputName: 'Number Range',
      inputPlaceholder: {
        separator: ':',
        from: 'fromNew',
        to: 'toNew',
      },
      inputMandatory: this.mandatory,
      inputValue: this.showDefaultValue
        ? {
            from: 1,
            to: 5,
          }
        : null,
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'custom',
              errorMessage: 'custom error',
              value: (control: AbstractControl) => {
                return (control as FormGroup).controls.from.value === 5
                  ? { custom: true }
                  : null;
              },
            },
            {
              id: 1,
              async: false,
              type: 'complex',
              value: {
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'max',
                    value: 7,
                    errorMessage: 'Number Range max 7',
                  },
                  {
                    id: 1,
                    async: false,
                    type: 'min',
                    value: 1,
                    errorMessage: 'Number Range min 5',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Number Range is required',
                  },
                  {
                    id: 1,
                    async: false,
                    type: 'max',
                    value: 10,
                    errorMessage: 'Number Range min 5',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : [
            /* {
              async: false,
              errorMessage: 'Invalid Number',
              id: 0,
              type: 'complex',
              value: {
                from: [
                  {
                    errorMessage: 'Invalid Number',
                    id: 0,
                    type: 'min',
                    value: 1,
                  },
                ],
                to: [
                  {
                    errorMessage: 'Invalid Number',
                    id: 1,
                    type: 'max',
                    value: 60,
                  },
                ],
              },
            }, */
            {
              id: 1,
              async: false,
              type: 'rangepickererror',
              errorMessage: '',
              value: rangePickerValidation,
            },
          ],
    },
    {
      inputId: 'dropdown',
      inputType: InputType.DROPDOWN,
      inputName: 'Dropdown',
      inputPlaceholder: 'Dropdown',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      hint: 'i m a hint.',
      clearable: true,
      groupBy: 'parent',
      inputValue: this.showDefaultValue ? { ...this.comboData[0] } : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. Dropdown is required. `,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'compareNumber',
      inputType: InputType.COMPARE_NUMBER,
      inputName: 'Compare number',
      inputPlaceholder: 'Enter value',
      inputMandatory: this.mandatory,
      inputOptions: this.compareOptions,
      inputValue: {
        operator: {
          optionText: '>=',
          optionValue: 6,
        },
        from: null,
        to: null,
      },
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'complex',
              value: {
                operator: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Select an operator',
                  },
                ],
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Compare number is required',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Compare number is required',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : undefined,
    },
    {
      inputId: 'decimal',
      inputType: InputType.DECIMAL,
      inputName: 'Decimal',
      inputPlaceholder: 'Enter a decimal',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Decimal is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'decimalRange',
      inputType: InputType.DECIMAL_RANGE,
      inputName: 'Decimal Range',
      inputPlaceholder: 'Select decimal range',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'complex',
              value: {
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Decimal Range is required',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Decimal Range is required',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : [
            {
              id: 1,
              async: false,
              type: 'rangepickererror',
              errorMessage: '',
              value: rangePickerValidation,
            },
          ],
    },
    {
      inputId: 'compareDecimal',
      inputType: InputType.COMPARE_DECIMAL,
      inputName: 'Compare decimal',
      inputPlaceholder: 'Enter value',
      inputMandatory: this.mandatory,
      inputOptions: this.compareOptions,
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'complex',
              value: {
                operator: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Select an operator',
                  },
                ],
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Compare decimal is required',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Compare decimal is required',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : undefined,
    },
    {
      inputId: 'email',
      inputType: InputType.EMAIL,
      inputName: 'Email',
      inputPlaceholder: 'Enter an email',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Email is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'password',
      inputType: InputType.PASSWORD,
      inputName: 'Password',
      inputPlaceholder: 'Enter a Password',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Password is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'multiselectDropdown',
      inputType: InputType.MULTI_SELECT_DROPDOWN,
      inputName: 'Multiselect dropdown',
      inputPlaceholder: 'Multiselect dropdown',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      visibleSelectedOptions: 3,
      inputValue: this.showDefaultValue
        ? [
            {
              optionValue: '3000865',
              optionText: 'Law',
              optionIcon: 'message',
            },
            {
              optionValue: '70001572',
              optionText: 'SS1',
              optionIcon: 'notifications',
            },
          ]
        : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Multiselect dropdown is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'timeRange',
      inputType: InputType.TIME_RANGE,
      inputName: 'Time Range',
      inputPlaceholder: 'Select time range',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              id: 0,
              async: false,
              type: 'complex',
              value: {
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Time Range is required',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Time Range is required',
                  },
                ],
              },
              errorMessage: '',
            },
          ]
        : undefined,
    },
    {
      inputId: 'time',
      inputType: InputType.TIME,
      inputName: 'Time',
      inputPlaceholder: 'Select time',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Time is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'radio',
      inputType: InputType.RADIO,
      inputName: 'Radio',
      inputDisabled: true,
      inputPlaceholder: 'Select an option',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      inputValue: this.showDefaultValue
        ? {
            optionValue: '3000865',
            optionText: 'Law',
            optionIcon: 'message',
          }
        : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Radio is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'toggleRadio',
      inputType: InputType.TOGGLE_RADIO,
      inputName: 'Toggle Radio',
      inputPlaceholder: 'Select an option',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Toggle Radio is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'checkbox',
      inputType: InputType.CHECKBOX,
      inputName: 'Checkbox',
      inputPlaceholder: 'Select options',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      inputValue: this.showDefaultValue
        ? [
            {
              optionValue: '3000865',
              optionText: 'Law',
              optionIcon: 'message',
            },
          ]
        : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. Checkbox is required. `,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'yesNo',
      inputType: InputType.YES_NO_OPTION,
      inputName: 'Yes No Input',
      inputMandatory: this.mandatory,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Yes No Input is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'toggleCheckbox',
      inputType: InputType.TOGGLE_CHECKBOX,
      inputName: 'Toggle Checkbox',
      inputPlaceholder: 'Select options',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Toggle Checkbox is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'orgSearch',
      inputType: InputType.ORG_SEARCH,
      inputName: 'Organization Search',
      inputPlaceholder: 'Select organizations',
      inputMandatory: this.mandatory,
      orgConfig: {
        prntId: '54',
        fetchPrntOrgOnlyFlag: 'false',
        multiselect: true,
        header: this.mandatory ? `*` : '',
        minLengthForSearch: 3,
        minLengthMessage: 'Enter value ',
      },
    },
    {
      inputId: 'empSearch',
      inputType: InputType.EMP_SEARCH,
      inputName: 'Employee Search',
      inputPlaceholder: 'Select employees',
      inputMandatory: this.mandatory,
      empConfig: {
        multiSelect: true,
        header: this.mandatory ? `*` : '',
        minLengthForSearch: 3,
        minLengthMessage: 'Enter value',
      },
    },
    {
      inputId: 'dropdownSearchSelection',
      inputType: InputType.DROPDOWN_SEARCH_SELECTION,
      inputName: 'Dropdown Search Selection',
      inputPlaceholder: 'Dropdown Search Selection',
      minTermLength: 2,
      typeToSearchText: 'Enter atleast 2 characters to search',
      inputMandatory: this.mandatory,
      showSearchIcon: true,
      multiple: false,
      inputOptions: (term: string) =>
        this.http
          .get('/admin/organization-search-details', {
            params: {
              prntId: '54',
              searchString: term,
              fetchPrntOrgOnlyFlag: 'false',
            },
          })
          .pipe(
            map(({ data }: any) =>
              data?.map(({ id, name }) => ({
                optionValue: id,
                optionText: name,
              }))
            )
          ) as Observable<ComboModel[]>,
      inputValue: this.showDefaultValue
        ? [
            {
              optionValue: '3000865',
              optionText: 'Law',
              optionIcon: 'message',
            },
            {
              optionValue: '70001572',
              optionText: 'SS1',
              optionIcon: 'notifications',
            },
          ]
        : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Multiselect dropdown is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'textarea',
      inputType: InputType.TEXT_AREA,
      inputName: 'Text Area',
      inputPlaceholder: 'Enter text area',
      inputMandatory: this.mandatory,
      hint: 'i m a hint',
      inputValue: this.showDefaultValue ? 'Asdf' : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Text Area is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'colorPicker',
      inputType: InputType.COLOR_PICKER,
      inputName: 'Color Picker',
      inputPlaceholder: 'Select Color',
      inputMandatory: this.mandatory,
      hint: 'i m a hint',
      inputValue: this.showDefaultValue ? '#000000' : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Color Picker is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
    {
      inputId: 'textRange',
      inputType: InputType.TEXT_RANGE,
      inputName: 'Text Range',
      inputPlaceholder: {
        separator: 'and',
        from: 'fromNew',
        to: 'toNew',
      },
      inputMandatory: this.mandatory,
      inputValue: this.showDefaultValue
        ? {
            from: 1,
            to: 5,
          }
        : null,
      validations: this.mandatory
        ? [
            /* {
              id: 0,
              async: false,
              type: 'custom',
              errorMessage: 'custom error',
              value: (control: AbstractControl) => {
                return (control as FormGroup).controls.from.value === 5
                  ? { custom: true }
                  : null;
              },
            },
            {
              id: 1,
              async: false,
              type: 'complex',
              value: {
                from: [
                  {
                    id: 0,
                    async: false,
                    type: 'max',
                    value: 7,
                    errorMessage: 'Number Range max 7',
                  },
                  {
                    id: 1,
                    async: false,
                    type: 'min',
                    value: 1,
                    errorMessage: 'Number Range min 5',
                  },
                ],
                to: [
                  {
                    id: 0,
                    async: false,
                    type: 'required',
                    value: null,
                    errorMessage: 'Number Range is required',
                  },
                  {
                    id: 1,
                    async: false,
                    type: 'max',
                    value: 10,
                    errorMessage: 'Number Range min 5',
                  },
                ],
              },
              errorMessage: '',
            }, */
          ]
        : [
            /* {
              id: 1,
              async: false,
              type: 'rangepickererror',
              errorMessage: '',
              value: rangePickerValidation,
            }, */
          ],
    },
    {
      inputId: 'multiItems',
      inputType: InputType.MULTI_ITEMS,
      inputName: 'Multi Items',
      inputPlaceholder: 'Multi Items',
      inputMandatory: this.mandatory,
      inputOptions: this.comboData,
      inputValue: this.showDefaultValue
        ? [
            {
              optionValue: '3000865',
              optionText: 'Law',
              optionIcon: 'message',
            },
            {
              optionValue: '70001572',
              optionText: 'SS1',
              optionIcon: 'notifications',
            },
          ]
        : null,
      validations: this.mandatory
        ? [
            {
              async: false,
              errorMessage: `Multi Items is required.`,
              type: 'required',
              value: null,
              id: 0,
            },
          ]
        : undefined,
    },
  ];

  ngOnInit(): void {}

  ngDoCheck(): void {
    // console.log('dg-dynamic-inupt-test::::::::::::::::doCheck');
  }

  ngAfterViewInit(): void {
    this.inputData = this.getFakeData();
    this.initializeFormGroup();
  }

  initializeFormGroup(): void {
    if (!this.inputData) return;
    const group = {};
    let validators = [];
    let asyncValidators = [];
    this.inputData.forEach((data) => {
      if (data?.validations) {
        data?.validations.forEach((validation) => {
          if (validation?.async)
            asyncValidators = [
              ...asyncValidators,
              getValidations(validation, this.getType(data)),
            ];
          else
            validators = [
              ...validators,
              getValidations(validation, this.getType(data)),
            ];
        });
      }
      //validators.push(Validators.required);
      if (this.getType(data)?.toString()) {
        if (isCompareInput(this.getType(data)))
          group[this.getId(data)] = new FormGroup({
            operator: new FormControl(null, validators?.[0]?.operator),
            from: new FormControl(null, validators?.[0]?.from),
            to: new FormControl(null, validators?.[0]?.to),
          });
        else if (isRangeInput(this.getType(data))) {
          const complexValidation = validators.find((v) => v?.isComplex);
          const normalValidations = validators.filter(
            (v) => v !== complexValidation
          );
          group[this.getId(data)] = new FormGroup(
            {
              from: new FormControl(null, complexValidation?.from),
              to: new FormControl(null, complexValidation?.to),
            },
            normalValidations
          );
        } else if (this.getType(data) === InputType.CHECKBOX) {
          const checkboxArray = [];
          this.getOptions(data)?.forEach(() => {
            checkboxArray.push(new FormControl(null));
          });
          group[this.getId(data)] = new FormArray(
            checkboxArray,
            validators,
            asyncValidators
          );
        } else {
          group[this.getId(data)] = new FormControl(
            null,
            validators,
            asyncValidators
          );
        }
      }
      validators = [];
      asyncValidators = [];
    });
    this.dgDynamicInputFormGroup = new FormGroup(group);
  }

  onInputChange = ({ data, currentValue, componentRef }) => {
    // Application Developer's code ;-)
    console.log('form validity: ', this.dgDynamicInputFormGroup?.valid);
  };

  onMandatoryChange = () => {
    this.inputData = this.getFakeData();

    /* this.inputData?.forEach((data) => {
      const requiredValidation = {
        async: false,
        errorMessage: `${this.getName(data)} is required.`,
        type: 'required',
        value: null,
        id: 0,
      };
      data[this.inputDataPropConfig.requiredProp] = this.mandatory;
      if (this.mandatory) {
        if (data?.validations?.toString()) {
          if (!data?.validations?.find((v) => v?.type === 'required')) {
            data.validations = [requiredValidation, ...data.validations];
          }
        } else {
          data.validations = [requiredValidation];
        }
      } else {
        if (
          data?.validations?.toString() &&
          data?.validations?.find((v) => v?.type === 'required')
        ) {
          data.validations = data?.validations?.filter(
            (validation) => validation?.type !== 'required'
          );
        }
      }
    }); */
    this.initializeFormGroup();
  };

  onShowDefaultValueChange = () => {
    this.onMandatoryChange();
  };

  onSearchClick() {
    console.log('%cSearch Clicked', 'font-size: 2em;color: purple');
  }

  onSubmit() {
    this.dgDynamicInputFormGroup.markAllAsTouched();
    console.log(
      '%cSubmit Clicked: ',
      'font-size: 2em;color: orange',
      this.dgDynamicInputFormGroup
    );
  }

  clear(input: InputDataModel) {
    this.dgDynamicInputFormGroup?.controls?.[input?.inputId]?.reset();
  }

  getId = (data: InputDataModel): string | number =>
    data?.[this.inputDataPropConfig?.idProp];

  getName = (data: InputDataModel): string =>
    data?.[this.inputDataPropConfig?.nameProp];

  getType = (data: InputDataModel): string | number =>
    data?.[this.inputDataPropConfig?.typeProp];

  getOptions = (data: InputDataModel): ComboModel[] =>
    data?.[this.inputDataPropConfig?.comboProp];

  getFormControlValue = (data: InputDataModel): unknown =>
    this.dgDynamicInputFormGroup?.controls[this.getId(data)]?.value;
}
